var React = require('react');

function TwitterXDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.27 4.18a.667.667 0 0 1 .033.942l-5.424 5.817 5.987 7.947a.667.667 0 0 1-.533 1.068h-3.652a.667.667 0 0 1-.532-.266l-4.214-5.592-5.263 5.645a.667.667 0 0 1-.975-.909l5.424-5.817-5.987-7.947A.667.667 0 0 1 4.666 4h3.653c.209 0 .406.099.532.266l4.213 5.591 5.263-5.645a.667.667 0 0 1 .942-.033h.001zm-6.767 7.149a.665.665 0 0 1-.052-.069L7.986 5.333H6.003l10.01 13.288h1.984l-5.494-7.292z","fillRule":"evenodd"}));
}

TwitterXDark.defaultProps = {"width":"24","fill":"#000","height":"24","viewBox":"0 0 24 24"};

module.exports = TwitterXDark;

TwitterXDark.default = TwitterXDark;
